import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';

const TrendChart: React.FC = () => {
  const chartRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (chartRef.current) {
      const chart = echarts.init(chartRef.current);

      const color = getComputedStyle(document.documentElement).getPropertyValue(
        '--color-primary-accent'
      );

      const option: echarts.EChartOption = {
        backgroundColor: 'transparent',
        xAxis: {
          type: 'category',
          data: [
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'J',
            'K',
            'L',
            'M',
          ],
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { show: false },
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { show: false },
          splitLine: { show: false },
        },
        series: [
          {
            data: [
              150, 230, 224, 218, 135, 147, 260, 312, 433, 201, 250, 376, 478,
            ],
            type: 'line',
            smooth: true,
            showSymbol: false,
            lineStyle: {
              color: color,
              width: 3,
            },
          },
        ],
      };

      chart.setOption(option);

      return () => {
        chart.dispose();
      };
    }
  }, []);

  return (
    <div className="trend-chart-container">
      <div className="chart-title">Alarm Trends</div>
      <div>
        <div ref={chartRef} style={{ width: '100%', height: '400px' }} />
      </div>
    </div>
  );
};

export default TrendChart;
